// Sol bölüm listesi rozeti — o bölümdeki açık tutarlılık bulgusu sayısı (0 ise görünmez).
import { REPORT_CHECK_COPY } from "../../lib/report-check-copy";
import { useReportCheckStore } from "../../stores/report-check-store";

export function ReportCheckBadge({ code }: { code: string }): JSX.Element | null {
  const n = useReportCheckStore((s) => s.current?.openCountBySection[code] ?? 0);
  const changed = useReportCheckStore((s) => s.current?.stale.changed.includes(code) ?? false);
  if (n === 0) return null;
  return (
    <span
      className="px-1.5 py-0.5 rounded text-xxs"
      data-testid={`report-check-badge-${code}`}
      title={changed ? REPORT_CHECK_COPY.badgeChanged : undefined}
      style={{
        background: "var(--color-warning-bg)",
        color: "var(--color-warning-text)",
        border: `1px ${changed ? "dashed" : "solid"} var(--color-warning-border)`,
        fontSize: "0.65rem",
        fontWeight: 600,
      }}
    >
      {n}
    </span>
  );
}
